$(document).ready(function(){
    // 加载类目树
    var category_tree = [];
    $.ajax({
      url: 'https://resource.freedomenduro.cn/config/categories.json',
      dataType: 'json',
      success: function(data) {
        if (data.success) {
          response = data;
          category_tree = response.result.items;
          /** 
           * 为防止document.ready前已经刷新数据，这种情况下触发Searchanise.ResultsUpdated事件
           */
          if(Searchanise && Searchanise.GetWidgets
             && Searchanise.GetWidgets().searchResults 
             && Searchanise.GetWidgets().searchResults.getPrevData
             && Searchanise.GetWidgets().searchResults.getPrevData()) {
            console.log('trigger Searchanise.ResultsUpdated');
            $(document).trigger('Searchanise.ResultsUpdated');
          }
        } else {
          console.error('Failed to fetch category data');
        }
      },
      error: function() {
        console.error('Failed to fetch category data');
      }
    })

    /*
     * query改写 
     */
    var rewrite = function(query) {
      const rewrite_data = {
          // 车品牌
          "suziki": ["铃木"],
          "honda": ["本田"],
          "gas gas": ["gasgas"],
          "husqvarna": ["胡斯", "胡斯瓦那", "胡思","胡思瓦纳","胡思瓦娜","胡斯瓦纳","胡斯瓦娜"],
          "kawasaki": ["川崎"],
          "yamaha": ["雅马哈"],
          // 品牌词
          "rekluse": ["蜘蛛"],
          "gaerne": ["大g"],
          "polisport": ["p牌"],
          "alpinestars": ["a星"],
          "akrapovic": ["天蝎排气","akrapovič"],
          "airoh": ["艾诺"],
          "maxima": ["美式马"],
          "montesa": ["梦特莎", "蒙特沙", "蒙特莎"],
          "motorex": ["摩托瑞士"],
          "tubliss": ["小红胎"],
      };

      const keywords = Object.keys(rewrite_data);
      var rewrite_query = query;
      for (const key of keywords) {
          const replacements = rewrite_data[key].sort((a, b) => b.length - a.length);
          for (const replacement of replacements) {
              const regex = new RegExp(replacement, 'gi');
              rewrite_query = rewrite_query.replace(regex, ` ${key} `);
          }
      }
    
      const segments = rewrite_query.split(' ');
      const processedSegments = segments.map((segment) => {
        if (segment.match(snizeQueryExeptions)) {
          return segment;
        }
    
        const regex = /[\u4e00-\u9fa5]+|[^\u4e00-\u9fa5]+/g;
        const processedSegment = segment.replace(regex, (match) => {
          return match.trim() + ' ';
        });
    
        return processedSegment.trim();
      });
    
      return processedSegments.join(' ').trim();
    }
    
    /*
     * query改写 
     * TODO 要改在 autocomplete 上的
     */
    $(document).on('Searchanise.DataRequestBefore', function (event, type, params) {
        if (type == 'results') {
          params.q = rewrite(params.q);
        }
    });

    /** 
     * 每次更新数据时同步更新筛选项
     */
    $(document).on('Searchanise.ResultsUpdated', function(event, input, container) {
      if(!Searchanise.GetWidgets().searchResults || !Searchanise.GetWidgets().searchResults.getPrevData()){
        return;
      }
      // 1. 顶部导航点击
      $("[searchanise-filter]").off("click");
      $("[searchanise-filter]").on("click", function(e) {
        e.preventDefault();
        // var keep_fields = [
        //   "filter_metafield_5636dc30d0e7c170dad956d059dc1677",
        //   "filter_metafield_672219d8aaa95893bbd4e9f019a00f72",
        //   "filter_metafield_7e7da200d1c7bcf4e65c266f4d6b4202",
        //   "filter_metafield_1c8c3def67309e5360a31c92c500d376",
        //   "filter_metafield_f3b9d5c8c7820c07dcef4c131c6c1a5c",
        //   "filter_metafield_a650f2ad91f604a46c8a7083bf59f1c6",
        //   "filter_metafield_cf27919a3e5d19b523351b90504f1217",
        //   "filter_metafield_0746ec2e4eeff41361be081e73dd5945",
        //   "filter_metafield_1f76bc57fa3f422ce56645924a6f882b",
        //   "filter_metafield_059e8944fcdb5b6f60522721bc6e4936",
        //   "filter_metafield_a1ec8da9d2f80fcc9ca3825ec2424061",
        //   "filter_metafield_5d1c4133d925469c89d3ee58d732566a",
        //   "filter_metafield_14177fb8b13908cb2f5cd7c79fa82e37",
        //   "filter_metafield_7d3178878dd236f427e34eecb1cc903e",
        //   "filter_metafield_0d54ba9e7f87ca5a3f005d3f5bc6746b",
        //   "filter_metafield_3f6f76c4909149e3c66088ddf050e968",
        //   "filter_metafield_a9fec6f6ecb092bbff979e1827978823",
        //   "filter_metafield_e42c830b84453228d408a39fafb68cf6",
        //   "filter_metafield_83db3e256caae204ba07228cfef7c721",
        //   "filter_metafield_af97b27b5545395de7a5e9892381175f",
        //   "filter_metafield_578553845ba6b686849a942b64427317",
        //   "filter_metafield_335cfbda0405af137b87476f9f1572ee",
        // ]
        var fields_mapping = {
          'product_type': 'product_type',
          'category_path': 'filter_metafield_e0ca6c2fc539feea10c5d7cc786b0b87',
          'category_level1': 'filter_metafield_335cfbda0405af137b87476f9f1572ee',
          'user_group': 'filter_metafield_f3ac72059298f656c86de8aa03d4f0ba',
          'riding_style': 'filter_metafield_ecaab92854f8358e9c4be2d4a1414e4f',
          'series': 'filter_metafield_4649670b7bc0688b169ab5b277426bda',
          'brand': 'vendor',
          // 'inventory_tag': 'filter_ptag_9e2950a49ed866e16094c4f402cc2531'
        }
        var filter = $(this).attr("searchanise-filter");
        var filters = JSON.parse(filter);
        newRestrictBy = {}
        $.each(filters, function(key, value){
          if(fields_mapping[key]){
            newRestrictBy[fields_mapping[key]] = value;
          }
        })
        Searchanise.GetWidgets().searchResults.search({ page: 1, restrictBy: newRestrictBy });
      });

      // 2. 手机搜索结果的筛选
      var results = Searchanise.GetWidgets().searchResults;
      var restrictBy = Searchanise.GetWidgets().searchResults.getPrevData().params.restrictBy;
      var query = Searchanise.GetWidgets().searchResults.getPrevData().params.q;
      var hideFacets = []; // 不做展示
      var ignoreSelectedFacets = []; // 忽略已选
      if(results && results.getPrevData() && results.getPrevData().result && $('.quick-filter').length == 0){
        var totalItemCount = results.getPrevData().result.totalItems;
        if(results.getPrevData().result.correctedQuery){
           totalItemCount = 0;
        }
        var facets = {}
        $.each(results.getPrevData().result.facets, function(index, each){
          facets[each['title']] = each;
        })

        // 2.0如果query和make一样，忽略query
        // 这里是个hack逻辑：
        // 为了让无query时用上Searchanise的排序功能，选择车型后，如果没有query会将query=make
        // 但是不能显示在页面上，所以还要去掉
        if(query && query == getUrlParam('_make_')){
          query = "";
          $(".search-field").val("");
        }
  
        // 2.1 如果没有车型适配商品，不出YMM的筛选
        // 2.1.1 如果强制出导航，不出YMM的筛选 优先级最高
        var page_type = getUrlParam('page_type');
        if(page_type && page_type != 'parts'){
          $('.section-ymm').hide();
          $('.collections-navigation').each(function() {
            var sectionId = $(this).data('section-id');
            if (sectionId && sectionId.indexOf('__navigation-' + page_type) > -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
          });
        }
        else {
          $('.collections-navigation').hide();
          // 2.1.2 如果命中适配车型，那么隐藏适配品牌筛选
          if($(".section-ymm").length > 0){
            if(!query || getUrlParam('_model_') 
               || results.getPrevData().result.totalItems == 0 
               || facets['适配品牌'] && facets['适配品牌']['buckets'].length > 0){
              $('.section-ymm').show();
              hideFacets.push('适配品牌');
              ignoreSelectedFacets.push('适配品牌');
            }
            else{
              $('.section-ymm').hide();
            }
          }
  
          // 如果命中装备，不出YMM的筛选
          if(query && facets['更多分类']) {
            var hit_count = 0;
            var total_count = results.getPrevData().result.totalItems;
            var selected = false;
            $.each(facets['更多分类']['buckets'], function(index, bucket){
              var categoryId = bucket['value'].split('.')[0];
              if(categoryId == '1'){
                hit_count = bucket['count'];
              }
            })
            if(total_count > 0 && hit_count / total_count >= 0.9){
              $('.section-ymm').hide();
            }
          }
        }
  
        // 2.2 如果选择的分类不在指定分类下，不出尺码选项
        if(facets['分类'] && facets['尺码']){
          // 选中尺码
          var selected_size = false;
          $.each(facets['尺码']['buckets'], function(index, bucket){
            if(bucket['selected']){
              selected_size = true;
              return;
            }
          })
          // 部分分类下出尺码
          var hit_categories = false;
          var hit_count = 0;
          var total_count = 0;
          $.each(facets['分类']['buckets'], function(index, bucket){
            total_count += bucket['count'];
            if(['头盔','骑行靴','骑行衣','骑行裤','护甲','护具','护膝','护肘','骑行夹克','手套','骑行服','骑行鞋','骑行袜'].indexOf(bucket['value']) >= 0){
              hit_count += bucket['count'];
              if(bucket['selected'] || bucket['value'] == query){
                hit_categories = true;
              }
            }
          })
          // 根据结果判断是否命中分类
          if(total_count > 0 && hit_count / total_count >= 0.8) {
            hit_categories = true;
          }
          if(!selected_size && !hit_categories){
            hideFacets.push('尺码');
          }
        }
  
        // 2.3 排序
        var total_properties = 0;
        var show_titles = ['品牌', '尺码', '适配品牌', '是否现货']; /** 适配品牌, 系列 */
        var show_facets = {}
        $.each(show_titles, function(idx, title){
          if(hideFacets.indexOf(title) >= 0){
            return;
          }
          total_properties += 1;
          if(facets[title] && total_properties <= 4){
            show_facets[title] = facets[title];
          }
        })
        
        // 2.4.1 已选择属性
        $(".total-count-filter-selected").remove();
        var totalCountContainer = $(`<div class="total-count-filter-selected" style="line-height: 25px; margin-top:10px; word-break:keep-all; color:rgb(51,51,51); font-size:12px; margin-left: calc(50% - 46vw); margin-right: calc(50% - 46vw);"><span class="total-count">共 <b>${totalItemCount}</b> 款商品</span></div>`);
        $('.snize-mobile-design .snize-main-panel').before(totalCountContainer);
        
        var selectedFilters = $('<span class="filter-selected">已选择: </span>');
        var total = 0;

        // query
        // if(query){
        //   total += 1;
        //   selectedFilters.append(`<div name="q" class="checkbox selected">关键词: ${query}</div>`);
        // }
        
        // filter
        $.each(facets, function(title, facet){
          $.each(facet['buckets'], function(index, bucket){
            if(bucket['selected'] && bucket['value'] != '有库存' && bucket['value'] != '国外期货' && ignoreSelectedFacets.indexOf(facet['title']) < 0){
              total += 1;
              var value = bucket['value'];
              if(facet['title'] == '更多分类'){
                value = bucket['value'].split('.')[1];
              }
              selectedFilters.append(`<div name="${facet['attribute']}" class="checkbox selected">${value}</div>`);
            }
          })
        })
        if(total > 0){
          totalCountContainer.append($('<span class="separator" aria-hidden="true"></span>'));
          totalCountContainer.append(selectedFilters)
        }
        
        // 2.4.2 是否现货、分类、品牌、尺码外透
        $('.snize-main-panel-mobile-filters').wrap('<div class="quick-filter-wrapper"></div>');
        var quickFilterBtnGroup = $('<div class="quick-filter" style="display:flex"></div>');
        $('.quick-filter-wrapper').append(quickFilterBtnGroup);
        var position = 1;
        // 分类逻辑
        if(category_tree && facets['更多分类']){
          var statistics = {};
          $.each(facets['更多分类']['buckets'], function(index, bucket){
            var value = bucket['value'].split('.')[0];
            statistics[value] = bucket;
          })
          var rootId = $('#rootId').val();
          var selector = $('<div class="dropdown-check-list"><span class="anchor">分类</span><ul class="items position-' + position +'"></ul><div class="items-bottom position-' + position +'"></div></div>');
          selector.appendTo(quickFilterBtnGroup);
          var categories = [];
          $.each(category_tree, function(idx, item){
            if(!rootId || item.id == rootId){
              $.each(item['child'], function(idx2, child){
                if(statistics[child['id']]){
                  categories.push(child);
                }
              })
            }
          })
          if(query) {
            categories = categories.sort(function(a, b) {
              return statistics[b['id']]['count'] - statistics[a['id']]['count'];
            })
          }
          $.each(categories, function(idx, item){
            var key = 'filter_metafield_e0ca6c2fc539feea10c5d7cc786b0b87';
            var id = item['id'];
            var value = statistics[id]['value'];
            var text = item['name'];
            var count = statistics[id]['count'];
            var selected = statistics[id]['selected'] == 'true' ? 'selected' : '';
            selector.find('.items').append('<li><div class="wrapper-checkbox"><label name="'+key+'" value="'+value+'" class="input-checkbox-label '+selected+'">'+text+'<span class="item-number">'+count+'</span>'+'</label></div></li>');          
            $.each(item['child'], function(idx3, child){
              if(statistics[child['id']]){
                var key = 'filter_metafield_e0ca6c2fc539feea10c5d7cc786b0b87';
                var id = child['id'];
                var value = statistics[id]['value'];
                var text = child['name'];
                var count = statistics[id]['count'];
                var selected = statistics[id]['selected'] == 'true' ? 'selected' : '';
                selector.find('.items').append('<li><div class="wrapper-checkbox wrapper-checkbox-lv2"><label name="'+key+'" value="'+value+'" class="input-checkbox-label '+selected+'">'+text+'<span class="item-number">'+count+'</span>'+'</label></div></li>');                              
              }
            })
          })
        }
        
        $.each(show_facets, function(title, each){
            position += 1;
            var selector = $('<div class="dropdown-check-list"><span class="anchor">' + each['title'].replace('是否现货','现货').replace('适配品牌','车型') + '</span><ul class="items position-' + position +'"></ul><div class="items-bottom position-' + position +'"></div></div>');
            selector.appendTo(quickFilterBtnGroup);
            $.each(each['buckets'], function(index, bucket){
              var key = each['attribute'];
              var value = bucket['value'];
              var text = value;
              var count = bucket['count'];
              var selected = bucket['selected'] == 'true' ? 'selected' : '';
              // if(value == '国外期货'){
              //   value = '有库存|国外期货';
              //   text = '包含国外期货';
              // }
              selector.find('.items').append('<li><div class="wrapper-checkbox"><label name="'+key+'" value="'+value+'" class="input-checkbox-label '+selected+'">'+text+'<span class="item-number">'+count+'</span>'+'</label></div></li>');
            })
            // 现货逻辑
            // if(each['title'] == '商品库存' && facets['现货类型']) {
            //   $.each(facets['现货类型']['buckets'], function(index, bucket){
            //     var key = facets['现货类型']['attribute'];
            //     var value = bucket['value'];
            //     var count = bucket['count'];
            //     var selected = bucket['selected'] == 'true' ? 'selected' : '';
            //     selector.find('.items label[value="有库存"]').closest('li').append('<li><div class="wrapper-checkbox wrapper-checkbox-lv2"><label name="'+key+'" value="'+value+'" class="input-checkbox-label '+selected+'">'+value+'<span class="item-number">'+count+'</span>'+'</label></div></li>');
            //   })
            // }
        })
  
        // 2.5 点击操作
        // key点击
        $(".dropdown-check-list").find('.anchor').click(function() {
          $(this).toggleClass('arrow-up');
          $(this).parent().toggleClass('visible');
          $(".anchor").not(this).removeClass("arrow-up");
          $(".dropdown-check-list").not($(this).parent()).removeClass("visible");
        });
        
        // value点击
        $('.wrapper-checkbox').click(function(){
          var checkbox=$(this).find(".input-checkbox-label");
          var key=$(checkbox).attr("name");
          var value=$(checkbox).attr("value");
          // 如果当前未选中，选择新的选项
          if(!$(checkbox).hasClass('selected')){
            $(checkbox).closest(".items").find('.input-checkbox-label[name="'+key+'"]').removeClass("selected");
            $(checkbox).addClass("selected");
            restrictBy[key] = value;
            // 库存逻辑
            // if(key == 'stock_status'){
            //   restrictBy['available_at_location'] = '';
            //   // restrictBy['quantity'] = '';
            // }
          }
          // 如果当前已选中，去掉该选项
          else {
            $(checkbox).removeClass("selected");
            var values = value.split('|');
            var new_values = []
            $(values, function(idx, each){
              if(each != value){
                new_values.push(each);
              }
            })
            restrictBy[key] = new_values.join('|');
          }
          console.log(restrictBy);
          Searchanise.GetWidgets().searchResults.search({ page: 1, restrictBy: restrictBy });
          // 回到结果页最前面
          var targetElement = $("#snize_results");
          var targetOffset = targetElement.offset().top - 240;
          $("html, body").animate({ scrollTop: targetOffset }, "slow");
        })

        // 去掉已选择选项的操作
        $(".filter-selected .selected").click(function(){
          var key = $(this).attr("name");
          // query
          if(key == 'q') {
            window.location.href = generateUrl(window.location.href, 'q', '');
          }
          // filter
          else {
            restrictBy[key] = "";
            Searchanise.GetWidgets().searchResults.search({ page: 1, restrictBy: restrictBy });
          }
        })
  
        // 2.6 滚动穿透问题
        $(".dropdown-check-list .items").on("touchstart", function(event) {
          $("body").css("overflow-y", "hidden");
        });
        $(".dropdown-check-list .items").on('touchend', function(event) {
          $("body").css("overflow-y", "auto");
        });
  
        // 2.7 操作商品区时关闭选项
        $(".snize-search-results-main-content").on("touchstart", function() {
          $(".anchor").removeClass("arrow-up");
          $(".dropdown-check-list").removeClass("visible");
        })
      }

      // 3. PC上不需要透出的字段隐藏:更多分类
      $('#snize_filters_block_filter_metafield_e0ca6c2fc539feea10c5d7cc786b0b87').hide();

      // 4. 特殊页面不需要筛选
      if(window.__sales_parts_page__){
        $('.snize-main-panel').hide();
      }
    });
    
  })